import { render, staticRenderFns } from "./footerPC.vue?vue&type=template&id=9b98f278&scoped=true"
import script from "./footerPC.vue?vue&type=script&lang=js"
export * from "./footerPC.vue?vue&type=script&lang=js"
import style0 from "./footerPC.vue?vue&type=style&index=0&id=9b98f278&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b98f278",
  null
  
)

export default component.exports